"use strict";
exports.__esModule = true;
var Generator = /** @class */ (function () {
    function Generator() {
    }
    Generator.generate = function (config) {
        var length = config.length;
        var letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var symbols = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~';
        var numbers = '012345678901234567890123456789012345678901234567890123456789';
        var characters = '';
        if (config.letters)
            characters += letters;
        if (config.symbols)
            characters += symbols;
        if (config.numbers)
            characters += numbers;
        if (!characters)
            return '';
        var rdn = function (n) { return Math.floor(Math.random() * n); };
        var rds = function (s) { return s[(rdn(s.length))]; };
        var s = '';
        for (var i = 0; i < length; i += 1) {
            s += rds(characters);
        }
        return s;
    };
    return Generator;
}());
exports["default"] = Generator;
//# sourceMappingURL=index.js.map